(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * jQuery-viewport-checker - v1.8.8 - 2017-09-25
 * https://github.com/dirkgroenen/jQuery-viewport-checker
 *
 * Copyright (c) 2017 Dirk Groenen
 * Licensed MIT <https://github.com/dirkgroenen/jQuery-viewport-checker/blob/master/LICENSE>
 */
!function (a) {
  a.fn.viewportChecker = function (b) {
    var c = {
      classToAdd: "visible",
      classToRemove: "invisible",
      classToAddForFullView: "full-visible",
      removeClassAfterAnimation: !1,
      offset: 100,
      repeat: !1,
      invertBottomOffset: !0,
      callbackFunction: function callbackFunction(a, b) {},
      scrollHorizontal: !1,
      scrollBox: window
    };
    a.extend(c, b);
    var d = this,
        e = {
      height: a(c.scrollBox).height(),
      width: a(c.scrollBox).width()
    };
    return this.checkElements = function () {
      var b, f;
      c.scrollHorizontal ? (b = Math.max(a("html").scrollLeft(), a("body").scrollLeft(), a(window).scrollLeft()), f = b + e.width) : (b = Math.max(a("html").scrollTop(), a("body").scrollTop(), a(window).scrollTop()), f = b + e.height), d.each(function () {
        var d = a(this),
            g = {},
            h = {};

        if (d.data("vp-add-class") && (h.classToAdd = d.data("vp-add-class")), d.data("vp-remove-class") && (h.classToRemove = d.data("vp-remove-class")), d.data("vp-add-class-full-view") && (h.classToAddForFullView = d.data("vp-add-class-full-view")), d.data("vp-keep-add-class") && (h.removeClassAfterAnimation = d.data("vp-remove-after-animation")), d.data("vp-offset") && (h.offset = d.data("vp-offset")), d.data("vp-repeat") && (h.repeat = d.data("vp-repeat")), d.data("vp-scrollHorizontal") && (h.scrollHorizontal = d.data("vp-scrollHorizontal")), d.data("vp-invertBottomOffset") && (h.scrollHorizontal = d.data("vp-invertBottomOffset")), a.extend(g, c), a.extend(g, h), !d.data("vp-animated") || g.repeat) {
          String(g.offset).indexOf("%") > 0 && (g.offset = parseInt(g.offset) / 100 * e.height);
          var i = g.scrollHorizontal ? d.offset().left : d.offset().top,
              j = g.scrollHorizontal ? i + d.width() : i + d.height(),
              k = Math.round(i) + g.offset,
              l = g.scrollHorizontal ? k + d.width() : k + d.height();
          g.invertBottomOffset && (l -= 2 * g.offset), k < f && l > b ? (d.removeClass(g.classToRemove), d.addClass(g.classToAdd), g.callbackFunction(d, "add"), j <= f && i >= b ? d.addClass(g.classToAddForFullView) : d.removeClass(g.classToAddForFullView), d.data("vp-animated", !0), g.removeClassAfterAnimation && d.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            d.removeClass(g.classToAdd);
          })) : d.hasClass(g.classToAdd) && g.repeat && (d.removeClass(g.classToAdd + " " + g.classToAddForFullView), g.callbackFunction(d, "remove"), d.data("vp-animated", !1));
        }
      });
    }, ("ontouchstart" in window || "onmsgesturechange" in window) && a(document).bind("touchmove MSPointerMove pointermove", this.checkElements), a(c.scrollBox).bind("load scroll", this.checkElements), a(window).resize(function (b) {
      e = {
        height: a(c.scrollBox).height(),
        width: a(c.scrollBox).width()
      }, d.checkElements();
    }), this.checkElements(), this;
  };
}(jQuery); //

(function ($, root, undefined) {
  $(function () {
    var $window = $(window),
        $body = $('body'),
        $header = $('#header'),
        $_bg_src = false,
        bg_breakpoint = 640; // Responsive bg images

    $_bg_src = $('*[data-bg-src]');
    setResponsiveBgSrc();
    $window.on('resize', setResponsiveBgSrc); // Check if elements enter or exit the viewport

    $('.check-vp').viewportChecker(); // Simulate hover on touch devices by adding a hover class

    $('.is-hoverable').on('touchstart touchend', function (e) {
      $(this).toggleClass('hovered');
    }); // Scroll to

    $('a[href^="#"]').on('click touchend', function (e) {
      e.preventDefault();
      var elem = $(this).attr('href');
      var position = $(elem).offset();
      $(this).attr("href", elem);
      $('html, body').animate({
        scrollTop: position.top + 1
      }, 500);
    }); // Off-canvas navigation

    var $navToggles = $('.nav-toggle'),
        $navText = $('.nav-toggle p');
    $navToggles.on('click touchend', triggerNav);

    function triggerNav(event) {
      event.preventDefault();

      if (!$body.hasClass('is-menu-open')) {
        $body.addClass('is-menu-open').removeClass('is-menu-closed');
        $navToggles.addClass('is-active');
        $navText.html($navText.data('text-open')); // Scroll to top to prevent gap

        $(window).scrollTop(0);
      } else {
        $body.removeClass('is-menu-open').addClass('is-menu-closed');
        $navToggles.removeClass('is-active');
        $navText.html($navText.data('text-close'));
      }
    } // Responsive images


    function loadBgSrc($el, src, size) {
      var img = new Image(),
          size = size || false;
      $el.data('bg-is-loading', true);

      img.onload = function () {
        if (_typeof(src) === 'object') {
          $el.data('bg-size', size);
        }

        $el.css('background-image', 'url(' + this.src + ')').addClass('is-loaded').data('bg-is-loaded', true).data('bg-is-loading', false);
      };

      if (_typeof(src) === 'object') {
        img.src = src[size];
      } else {
        img.src = src;
      }
    }

    function setResponsiveBgSrc() {
      if (!$_bg_src.length) {
        return;
      }

      $_bg_src.each(function (index, el) {
        var $el = $(el),
            isLoading = $el.data('bg-is-loading') || false,
            isLoaded = $el.data('bg-is-loaded') || false,
            size = $el.data('bg-size') || false,
            src = $el.data('bg-src');

        if (typeof src === 'string' && isLoaded) {
          return;
        } else if (typeof src === 'string' && !isLoaded && !isLoading) {
          loadBgSrc($el, src);
        } else if (_typeof(src) === 'object' && !isLoading) {
          if ($window.width() >= bg_breakpoint && size !== 'large') {
            loadBgSrc($el, src, 'large');
          } else if ($window.width() < bg_breakpoint && size !== 'small') {
            loadBgSrc($el, src, 'small');
          }
        }
      });
    }
    /**
     * Anchor scroll to element on click
     */


    $('a[href^="/#"]').on('click touchend', function () {
      var elem = $(this).attr('href').replace('/', '');
      var position = $(elem).offset();
      var header = $('#header').height();
      $(this).attr("href", elem);
      $('html, body').animate({
        scrollTop: position.top - header
      }, 500);
    });
    var swiper1 = new Swiper("#swiper1", {
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    var swiper2 = new Swiper("#swiper2", {
      slidesPerView: "auto",
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }); // Lang switch

    $(".lang-switch").hover(function () {
      $(this).addClass('lang-switch--open');
    }, function () {
      $(this).removeClass('lang-switch--open');
    });
    $('#showAllPersons').on('click touchend', function () {
      $('.person').removeClass('person--hide');
      this.remove();
    });
  });
})(jQuery, void 0);

},{}]},{},[1]);
